import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-hvad-der-skete';
            break;
        case 'beskriv-hvad-der-skete':
            nextPage = 'beskriv-skade-ting';
            break;
        case 'beskriv-skade-ting':
            nextPage = 'maerke-og-model';
            break;
        case 'maerke-og-model':
            nextPage = 'hvornaar-er-den-koebt';
            break;
        case 'hvornaar-er-den-koebt':
            nextPage = 'hvor-er-den-koebt';
            break;
        case 'hvor-er-den-koebt':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'andet-selskab';
            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'i-hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'i-hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
